import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { IPortfolioData } from "../services/zeos-api/contracts/PortfolioData";
import { RootState } from "./Store";

interface IPortfolioState {
  selectedProperty: IPortfolioData | null;
}

const initialState: IPortfolioState = {
  selectedProperty: null,
};

const portfolioSlice = createSlice({
  name: "portfolio",
  initialState,
  reducers: {
    setSelectedProperty(state, action: PayloadAction<IPortfolioData>) {
      state.selectedProperty = action.payload;
    },
    clearSelectedProperty(state) {
      state.selectedProperty = null;
    },
  },
});

export const { setSelectedProperty, clearSelectedProperty } =
  portfolioSlice.actions;

export const selectedPropertySelector = (state: RootState) =>
  state.portfolio.selectedProperty;

export default portfolioSlice.reducer;
